import { render, staticRenderFns } from "./FinancialDataField.vue?vue&type=template&id=2e452ca4"
import script from "./FinancialDataField.vue?vue&type=script&lang=js"
export * from "./FinancialDataField.vue?vue&type=script&lang=js"
import style0 from "./FinancialDataField.vue?vue&type=style&index=0&id=2e452ca4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports